import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MessagingSubscriptionEffects } from './messaging-subscription.effects';
import { LocalStorageTopicStorage } from './topic-storage/localestorage-topic-storage';
import { TOPIC_STORAGE } from './topic-storage/topic-storage.api';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([MessagingSubscriptionEffects])],
  providers: [
    {
      provide: TOPIC_STORAGE,
      useClass: LocalStorageTopicStorage,
    },
  ],
})
export class MessagingSubscriptionModule {}
